export const ChapterActions = {
    GET_CHAPTER_DATA: "GET_CHAPTER_DATA",
    SET_CHAPTER_DATA: "SET_CHAPTER_DATA",
    // define other action types here
  };
  